import { Platform } from 'react-native';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const Web = require("./home-gym.web").default;
// eslint-disable-next-line @typescript-eslint/no-require-imports
const Native = require("./home-gym.native").default;
export default Platform.OS === "web" ? Web : Native;
